import axios from 'axios';

import { DefaultClass } from '../models/DefaultClass';

const uri = '/defaultclass';

const create = async (classification: DefaultClass) => {
  const { data } = await axios.post<DefaultClass>(`${uri}`, classification);
  return data;
};

const get = async (id: number) => {
  const { data } = await axios.get<DefaultClass>(`${uri}/${id}`);
  return data;
};

const getAll = async () => {
  const { data } = await axios.get<DefaultClass[]>(`${uri}`);
  return data;
};

const getDefault = async () => {
  const { data } = await axios.get<DefaultClass[]>(`${uri}`);
  return data;
};

const update = async (classification: DefaultClass) => {
  const { data } = await axios.put<DefaultClass>(
    `${uri}/${classification.id}`,
    classification
  );
  return data;
};

const remove = async (classification: DefaultClass) => {
  const { data } = await axios.delete(`${uri}/${classification.id}`);
  return data;
};

const apis = {
  create,
  get,
  getAll,
  getDefault,
  remove,
  update,
};

export default apis;
